import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logoIcon from '../components/assets/icon.png';
import Footer from '../components/Footer';
import EnquiryModal from '../components/EnquiryModal';
import '../App.css';

const FilmProduction = () => {
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleMenuClick = () => {
    setIsMenuOpen(false);
    setIsDropdownOpen(false);
    document.body.style.overflow = 'unset';
  };

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className="service-page">
      {/* Header */}
      <nav className="navbar scrolled">
        <div className="container nav-content">
          <Link to="/" className="logo">
            <img src={logoIcon} alt="Magic Moon Studios" className="logo-icon-img" />
            <span className="logo-text">MAGIC MOON STUDIOS</span>
          </Link>

          <button 
            className="mobile-menu-btn" 
            onClick={(e) => {
              e.stopPropagation();
              setIsMenuOpen(!isMenuOpen);
              setIsDropdownOpen(false);
              document.body.style.overflow = isMenuOpen ? 'unset' : 'hidden';
            }}
          >
            {isMenuOpen ? '✕' : '☰'}
          </button>

          {isMenuOpen && (
            <div 
              className="mobile-menu-backdrop" 
              onClick={(e) => {
                e.stopPropagation();
                setIsMenuOpen(false);
                setIsDropdownOpen(false);
                document.body.style.overflow = 'unset';
              }}
            />
          )}

          <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <li><Link to="/" onClick={handleMenuClick}>Home</Link></li>
            <li><a href="/#about" onClick={handleMenuClick}>About</a></li>
            <li><a href="/#projects" onClick={handleMenuClick}>Projects</a></li>
            <li className={`dropdown ${isDropdownOpen ? 'active' : ''}`}>
              <a href="#services" onClick={toggleDropdown}>Services ▾</a>
              <ul className="dropdown-menu">
                <li><Link to="/film-production" onClick={handleMenuClick}>Film Production</Link></li>
                <li><Link to="/short-movies" onClick={handleMenuClick}>Short Movies</Link></li>
                <li><Link to="/academy" onClick={handleMenuClick}>Academy</Link></li>
                <li><Link to="/ads-making" onClick={handleMenuClick}>Ads Making</Link></li>
                <li><Link to="/digital-content" onClick={handleMenuClick}>Digital Content</Link></li>
                <li><Link to="/music-production" onClick={handleMenuClick}>Music Production</Link></li>
              </ul>
            </li>
            <li><a href="/#team" onClick={handleMenuClick}>Team</a></li>
            <li><a href="/#contact" className="contact-btn" onClick={handleMenuClick}>Contact</a></li>
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="service-hero" style={{ 
        background: 'linear-gradient(rgba(15, 52, 96, 0.9), rgba(26, 26, 46, 0.9)), url("https://images.unsplash.com/photo-1485846234645-a62644f84728?q=80&w=2000&auto=format&fit=crop")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        position: 'relative'
      }}>
        <div className="container">
          <div className="service-hero-content" style={{ 
            textAlign: 'center',
            maxWidth: '900px',
            margin: '0 auto'
          }}>
            <h1 className="service-hero-title" style={{
              fontSize: '4rem',
              fontWeight: '800',
              color: '#FFFFFF',
              marginBottom: '20px',
              textShadow: '2px 2px 8px rgba(0, 0, 0, 0.3)',
              letterSpacing: '2px'
            }}>Film Production</h1>
            <p className="service-hero-subtitle" style={{
              fontSize: '1.5rem',
              color: '#87CEEB',
              lineHeight: '1.8',
              fontWeight: '400'
            }}>
              Full-scale feature film production with professional crew and state-of-the-art equipment
            </p>
          </div>
        </div>
      </section>

      {/* Overview Section */}
      <section className="service-overview">
        <div className="container">
          <div className="overview-grid">
            <div className="overview-content">
              <h2 style={{ 
                fontFamily: "'Brush Script MT', 'Lucida Handwriting', cursive",
                color: '#5B9BD5', 
                marginBottom: '20px',
                fontSize: '2.5rem',
                background: 'linear-gradient(135deg, #5B9BD5 0%, #87CEEB 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                border: '2px solid #B8860B',
                padding: '15px',
                borderRadius: '10px',
                backgroundColor: 'rgba(91, 155, 213, 0.1)'
              }}>Our Film Production Services</h2>
              <p style={{ lineHeight: '1.8', marginBottom: '20px' }}>
                At Magic Moon Studios, we bring your cinematic vision to life with comprehensive film production services. 
                From concept development to final delivery, our experienced team ensures every frame tells your story perfectly.
              </p>
              <p style={{ lineHeight: '1.8', marginBottom: '20px' }}>
                We handle all aspects of production including pre-production planning, on-set filming, 
                post-production editing, color grading, sound design, and visual effects. Our state-of-the-art facilities 
                and cutting-edge technology enable us to deliver Hollywood-quality productions.
              </p>
            </div>
            <div className="overview-image">
              <img 
                src="https://images.unsplash.com/photo-1574267432644-f937cf77db70?q=80&w=800&auto=format&fit=crop" 
                alt="Film Production Equipment"
                style={{ 
                  width: '100%', 
                  height: '400px', 
                  objectFit: 'cover',
                  borderRadius: '15px',
                  border: '4px solid #B8860B',
                  boxShadow: '0 8px 30px rgba(184, 134, 11, 0.4)'
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services We Offer */}
      <section className="service-offerings" style={{ background: 'linear-gradient(to bottom, #F0F9FF 0%, #E3F2FD 100%)', padding: '80px 0' }}>
        <div className="container">
          <h2 style={{ 
            textAlign: 'center', 
            fontFamily: "'Brush Script MT', 'Lucida Handwriting', cursive",
            background: 'linear-gradient(135deg, #5B9BD5 0%, #87CEEB 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            marginBottom: '50px', 
            fontSize: '3rem',
            border: '3px solid #B8860B',
            padding: '20px',
            borderRadius: '15px',
            backgroundColor: 'rgba(91, 155, 213, 0.1)',
            width: 'fit-content',
            margin: '0 auto 50px auto'
          }}>What We Offer</h2>
          <div className="offerings-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px' }}>
            {[
              { title: 'Pre-Production', desc: 'Script development, storyboarding, location scouting, and casting', img: 'https://images.unsplash.com/photo-1542435503-956c469947f6?q=80&w=400&auto=format&fit=crop' },
              { title: 'Production', desc: 'Professional filming with 4K/8K cameras, lighting, and sound equipment', img: 'https://images.unsplash.com/photo-1492619375914-88005aa9e8fb?q=80&w=400&auto=format&fit=crop' },
              { title: 'Post-Production', desc: 'Editing, color grading, VFX, sound design, and music composition', img: 'https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?q=80&w=400&auto=format&fit=crop' },
              { title: 'Distribution', desc: 'Theater releases, streaming platform distribution, and marketing', img: 'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?q=80&w=400&auto=format&fit=crop' }
            ].map((service, index) => (
              <div key={index} style={{
                background: 'rgba(91, 155, 213, 0.1)',
                padding: '30px',
                borderRadius: '15px',
                border: '3px solid #B8860B',
                textAlign: 'center',
                transition: 'transform 0.3s ease',
                boxShadow: '0 5px 20px rgba(184, 134, 11, 0.3)',
                overflow: 'hidden'
              }}>
                <img 
                  src={service.img} 
                  alt={service.title}
                  style={{
                    width: '100%',
                    height: '200px',
                    objectFit: 'cover',
                    borderRadius: '10px',
                    marginBottom: '15px',
                    border: '2px solid #B8860B'
                  }}
                />
                <h3 style={{ 
                  fontFamily: "'Brush Script MT', 'Lucida Handwriting', cursive",
                  background: 'linear-gradient(135deg, #FFD700 0%, #B8860B 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  marginBottom: '10px',
                  fontSize: '1.8rem'
                }}>{service.title}</h3>
                <p style={{ color: '#666', lineHeight: '1.6' }}>{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta" style={{ 
        background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)', 
        padding: '80px 0',
        textAlign: 'center',
        color: '#fff'
      }}>
        <div className="container">
          <h2 style={{ 
            fontSize: '3rem', 
            marginBottom: '20px', 
            fontFamily: "'Brush Script MT', 'Lucida Handwriting', cursive",
            background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            border: '3px solid #B8860B',
            padding: '15px',
            borderRadius: '12px',
            backgroundColor: 'rgba(184, 134, 11, 0.2)',
            display: 'inline-block'
          }}>Ready to Create Your Film?</h2>
          <p style={{ fontSize: '1.2rem', marginBottom: '30px', color: '#87CEEB' }}>
            Let's discuss your project and bring your vision to life
          </p>
          <button onClick={() => setIsEnquiryOpen(true)} style={{
            display: 'inline-block',
            padding: '15px 40px',
            background: 'linear-gradient(135deg, #B8860B 0%, #FFD700 100%)',
            color: '#1a1a2e',
            borderRadius: '30px',
            fontWeight: '700',
            border: 'none',
            cursor: 'pointer',
            fontSize: '1rem',
            transition: 'transform 0.3s ease'
          }}>
            Get Started
          </button>
        </div>
      </section>

      {/* Enquiry Modal */}
      <EnquiryModal 
        isOpen={isEnquiryOpen} 
        onClose={() => setIsEnquiryOpen(false)} 
        serviceName="Film Production"
      />

      {/* Footer Component */}
      <Footer />
    </div>
  );
};

export default FilmProduction;
